var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-10px uppercase py-4px px-6px border-2 rounded-full",class:_vm.colorClasses},[_vm._v(_vm._s(_vm.$t('upc.myServers.beta')))])
}
var staticRenderFns = []

export { render, staticRenderFns }